<template>
  <AuthLayout
    mode="register"
    sidebar-title="Almost there"
    sidebar-text="Optionally invite an account manager for your practice."
    :support-phone="supportPhone"
    :progress-steps="practiceSteps"
    :progress-current-step="3"
    :title="classic ? 'Create Account manager' : 'Create account manager'"
    :subtitle="classic ? 'Step 3. Account manager.\n(Create if you need account manager or skip this step)' : 'Add a team member or skip this step.'"
    :classic="classic"
    classic-register-url=""
  >
    <template v-if="classic" #classic-subtitle>
      <span class="classic-auth__accent">Step 3.</span> Account manager.<br>
      (Create if you need account manager or skip this step)
    </template>

    <form class="auth-register__form" @submit.prevent="handleSubmit">
      <AuthField
        id="manager-first-name"
        v-model="form.first_name"
        label="First Name *"
        :error="fieldErrors.first_name"
        required
      />

      <AuthField
        id="manager-last-name"
        v-model="form.last_name"
        label="Last Name *"
        :error="fieldErrors.last_name"
        required
      />

      <AuthField
        id="manager-email"
        v-model="form.email"
        label="Email *"
        type="email"
        :error="fieldErrors.email"
        required
      />

      <AuthField
        id="manager-phone"
        v-model="form.phone_number"
        :label="classic ? 'Mobile Phone *' : 'Phone Number *'"
        type="tel"
        input-mask="phone"
        placeholder="000-000-0000"
        :error="fieldErrors.phone_number"
        required
      />

      <span v-if="formError" class="auth-login__error-block" role="alert">{{ formError }}</span>

      <div class="auth-login__actions">
        <AuthButton v-if="classic" variant="outline" :loading="loading" @click="emit('skip')">
          Skip
        </AuthButton>
        <AuthButton type="submit" :loading="loading">{{ classic ? 'Create' : 'Create account manager' }}</AuthButton>
        <AuthButton v-if="!classic" variant="ghost" :loading="loading" @click="emit('skip')">
          Skip this step
        </AuthButton>
      </div>
    </form>
  </AuthLayout>
</template>

<script setup>
import { reactive } from 'vue'
import AuthLayout from '../../shared/components/AuthLayout.vue'
import AuthField from '../../shared/components/AuthField.vue'
import AuthButton from '../../shared/components/AuthButton.vue'
import { PRACTICE_STEPS } from '../constants/steps.js'

defineProps({
  loading:     { type: Boolean, default: false },
  formError:   { type: String, default: '' },
  fieldErrors: { type: Object, default: () => ({}) },
  supportPhone: { type: String, default: '815-908-2020' },
  classic:      { type: Boolean, default: false },
})

const emit = defineEmits(['submit', 'skip'])

const practiceSteps = PRACTICE_STEPS

const form = reactive({
  first_name: '',
  last_name: '',
  email: '',
  phone_number: '',
})

const handleSubmit = () => {
  emit('submit', { ...form })
}
</script>
